import { NgModule } from '@angular/core';

import { ButtonLoadingIndicatorComponent } from './button-loading-indicator.component';
export { ButtonLoadingIndicatorComponent };

@NgModule({
  imports: [ButtonLoadingIndicatorComponent],
  exports: [ButtonLoadingIndicatorComponent],
})
export class GalaxyButtonLoadingIndicatorModule {}
